// Actions
export const FETCH_JOB_PREFERENCE = 'candidateExperience/views/employmentPreferences/FETCH_JOB_PREFERENCE'
export const FETCH_JOB_PREFERENCE_SUCCESS = 'candidateExperience/views/employmentPreferences/FETCH_JOB_PREFERENCE_SUCCESS'
export const FETCH_JOB_PREFERENCE_ERROR = 'candidateExperience/views/employmentPreferences/FETCH_JOB_PREFERENCE_ERROR'

export const UPDATE_JOB_PREFERENCE = 'candidateExperience/views/employmentPreferences/UPDATE_JOB_PREFERENCE'
export const UPDATE_JOB_PREFERENCE_SUCCESS = 'candidateExperience/views/employmentPreferences/UPDATE_JOB_PREFERENCE_SUCCESS'
export const UPDATE_JOB_PREFERENCE_ERROR = 'candidateExperience/views/employmentPreferences/UPDATE_JOB_PREFERENCE_ERROR'

export const FETCH_STATIC_COUNTRIES = 'candidateExperience/views/employmentPreferences/FETCH_STATIC_COUNTRIES'
export const FETCH_STATIC_COUNTRIES_SUCCESS = 'candidateExperience/views/employmentPreferences/FETCH_STATIC_COUNTRIES_SUCCESS'
export const FETCH_STATIC_COUNTRIES_ERROR = 'candidateExperience/views/employmentPreferences/FETCH_STATIC_COUNTRIES_ERROR'

// Action creators
export const fetchJobPreference = id => ({
  type: FETCH_JOB_PREFERENCE,
  meta: { id },
  payload: {
    fetchingJobPreference: true,
    fetchJobPreferenceError: null,
  },
})

export const fetchJobPreferenceSuccess = (id, { result }) => ({
  type: FETCH_JOB_PREFERENCE_SUCCESS,
  meta: { id },
  payload: {
    fetchingJobPreference: false,
    lastUpdatedJobPreference: Date.now(),
    jobPreference: result.id,
  },
})

export const fetchJobPreferenceError = (id, errorMessage) => ({
  type: FETCH_JOB_PREFERENCE_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const updateJobPreference = (id, data, resolve, reject) => ({
  type: UPDATE_JOB_PREFERENCE,
  meta: { id, data, resolve, reject },
  payload: {
    updatingJobPreference: true,
    updateJobPreferenceError: null,
  },
})

export const updateJobPreferenceSuccess = (id, { result }) => ({
  type: UPDATE_JOB_PREFERENCE_SUCCESS,
  meta: { id },
  payload: {
    updatingJobPreference: false,
    lastUpdatedJobPreference: Date.now(),
  },
})

export const updateJobPreferenceError = (id, errorMessage) => ({
  type: UPDATE_JOB_PREFERENCE_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const fetchStaticCountries = () => ({
  type: FETCH_STATIC_COUNTRIES,
  payload: {
    fetchingStaticCountries: true,
    fetchStaticCountriesError: null,
  },
})

export const fetchStaticCountriesSuccess = ({ result }) => ({
  type: FETCH_STATIC_COUNTRIES_SUCCESS,
  payload: {
    fetchingStaticCountries: false,
    lastUpdatedStaticCountries: Date.now(),
    staticCountries: result.map(country => country.id),
  },
})

export const fetchStaticCountriesError = errorMessage => ({
  type: FETCH_STATIC_COUNTRIES_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

const defaultView = {
  staticCountries: [],
  lastUpdatedStaticCountries: null,
  fetchingStaticCountries: false,
  fetchStaticCountriesError: null,

  jobPreference: null,
  lastUpdatedJobPreference: null,
  fetchingJobPreference: false,
  fetchJobPreferenceError: null,
  updatingJobPreference: false,
  updateJobPreferenceError: null,
}

const view = (state = defaultView, { type, payload }) => {
  switch (type) {
    case FETCH_JOB_PREFERENCE:
    case FETCH_JOB_PREFERENCE_SUCCESS:
    case UPDATE_JOB_PREFERENCE:
    case UPDATE_JOB_PREFERENCE_SUCCESS:
    case FETCH_STATIC_COUNTRIES:
    case FETCH_STATIC_COUNTRIES_SUCCESS:
      return { ...state, ...payload }

    case FETCH_JOB_PREFERENCE_ERROR:
      return {
        ...state,
        fetchingJobPreference: false,
        fetchJobPreferenceError: payload,
      }

    case UPDATE_JOB_PREFERENCE_ERROR:
      return {
        ...state,
        updatingJobPreference: false,
        updateJobPreferenceError: payload,
      }

    case FETCH_STATIC_COUNTRIES_ERROR:
      return {
        ...state,
        fetchingStaticCountries: false,
        fetchStaticCountriesError: payload,
      }

    default:
      return state
  }
}

export default view

export const getEmploymentPreferencesView = state => state.views.profile.employmentPreferences || defaultView
